"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackProductImpressions = void 0;
var _ = __importStar(require("underscore"));
var DeviceManager_1 = require("../components/DeviceManager");
var dom_interact_1 = require("./dom-interact");
var EnhanceEcommerce_1 = require("./EnhanceEcommerce");
function trackProductImpressions(categoryList) {
    var queue = [];
    var deviceManager = new DeviceManager_1.DeviceManager();
    function productImpressionsTracking() {
        var notTrackedProductList = categoryList.querySelectorAll('.js-category-item:not([data-tracked]), .content-insert:not([data-tracked])');
        for (var i = 0; i < notTrackedProductList.length; i++) {
            var productTile = notTrackedProductList[i];
            var GAP = productTile.getBoundingClientRect().height / 1.5;
            if ((0, dom_interact_1.isPartiallyInViewport)(productTile, -GAP)) {
                var scriptTag = productTile.querySelector('.js-product-data');
                var overwriteCategoryPreConfigTags = productTile.querySelectorAll('.overwrite-data');
                var productJSON = JSON.parse(scriptTag.innerHTML);
                for (var i_1 = 0; i_1 < overwriteCategoryPreConfigTags.length; i_1++) {
                    _.extend(productJSON.categoryPreConfig, JSON.parse(overwriteCategoryPreConfigTags[i_1].innerHTML));
                }
                productJSON.position = productTile.getAttribute('data-grid-position');
                productJSON.contentInsert = productTile.classList.contains('content-insert');
                productJSON.category = categoryName; // categoryName exists in the global scope
                queue.push(productJSON);
                productTile.setAttribute('data-tracked', 'true');
                if (deviceManager.isMobileDevice()) {
                    if (queue.length === 2) {
                        queue = EnhanceEcommerce_1.EnhanceEcommerce.trackProductImpressions(queue);
                    }
                }
                else if (queue.length === 3) {
                    queue = EnhanceEcommerce_1.EnhanceEcommerce.trackProductImpressions(queue);
                }
            }
        }
        if (notTrackedProductList.length === 0 && queue.length > 0) {
            queue = EnhanceEcommerce_1.EnhanceEcommerce.trackProductImpressions(queue);
        }
    }
    if (EnhanceEcommerce_1.EnhanceEcommerce.isTrackingEnabled()) {
        document.addEventListener('scroll', _.throttle(function () { return productImpressionsTracking(); }, 800));
        productImpressionsTracking();
        var mutationObserverConfig = { childList: true };
        var mutationObserver = new MutationObserver(productImpressionsTracking);
        mutationObserver.observe(categoryList, mutationObserverConfig);
    }
}
exports.trackProductImpressions = trackProductImpressions;
